// Style

import '../sass/main.scss';
import './functions/main-page';

// eslint-disable-next-line no-empty-function
$( document ).ready( () => {} );

$( document ).ready( function () {
	$( '.owl-carousel' ).owlCarousel( {
		items: 5,
		loop: true,
		nav: false,
		pagination: false,
		autoplay: true,
		autoplayTimeout: 4000,
		dots: false,
		autoplayHoverPause: true,
		responsive: {
			0: {
				items: 1,
				center: true,
				autoplayTimeout: 3000,
				loop: true,
			},
			800: {
				items: 3,
				loop: true,
			},
			1000: {
				items: 4,
				loop: true,
			},
			1200: {
				items: 5,
				loop: true,
			},
		},
	} );
} );
